/**
 * TanStack Query keys for the billing feature. Mutations must reach for
 * this factory rather than inline string-array literals so a future rename
 * stays a one-file change.
 */
export const BILLING_QUERY_KEYS = {
    all: ['billing'] as const,
    subscription: () => ['billing', 'subscription'] as const,
    plans: () => ['billing', 'plans'] as const,
    usage: () => ['billing', 'usage'] as const,
    limits: () => ['billing', 'limits'] as const,
    usageHistories: () => ['billing', 'usage-history'] as const,
    usageHistory: (params?: object) => ['billing', 'usage-history', params] as const,
    creditTransactionsAll: () => ['billing', 'credit-transactions'] as const,
    creditTransactions: (params?: object) => ['billing', 'credit-transactions', params] as const,
    addOns: () => ['billing', 'add-ons'] as const,
    invoicesAll: () => ['billing', 'invoices'] as const,
    invoices: (params?: object) => ['billing', 'invoices', params] as const,
    usageDailyAll: () => ['billing', 'usage-daily'] as const,
    usageDaily: (params?: object) => ['billing', 'usage-daily', params] as const,
} as const;

/**
 * Mutation `meta` marker: "this changes how much of a plan-limited resource
 * the org occupies". Put it on creates, deletes, imports and the
 * publish/archive transitions of gauge-counted objects — anything the
 * subscription plan caps. The app's `mutationCache` (`App.tsx`) reads it and
 * refreshes `usage()` centrally, so a warning clears on its own once usage
 * drops back under the limit.
 */
export const REFRESHES_PLAN_USAGE = { refreshesPlanUsage: true } as const;
